import json from './sprite.js';

export default {
    handle: 'ENG_NarratorVideo',
    label: 'en_ER-NarratorVideo_233681330',
    json,
};
